'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _createTemplateComponent = require('helpers/createTemplateComponent');

var _createTemplateComponent2 = _interopRequireDefault(_createTemplateComponent);

var _templateModeTypes = require('constants/templateModeTypes');

var _Email = require('components/common/Email');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Email = function (_Component) {
  (0, _inherits3.default)(Email, _Component);

  function Email() {
    (0, _classCallCheck3.default)(this, Email);
    return (0, _possibleConstructorReturn3.default)(this, (Email.__proto__ || (0, _getPrototypeOf2.default)(Email)).apply(this, arguments));
  }

  (0, _createClass3.default)(Email, [{
    key: 'render',

    // static propTypes = propTypes;

    value: function render() {
      var _props = this.props,
          components = _props.components,
          id = _props.id;


      return _react2.default.createElement(
        _Email.Table,
        { width: '100%', 'data-editor-id': id },
        _react2.default.createElement(
          _Email.TBody,
          null,
          this.props.panels.map(function (p) {
            return _react2.default.createElement(
              _Email.TR,
              { key: p },
              _react2.default.createElement(
                _Email.TD,
                null,
                _react2.default.createElement((0, _createTemplateComponent2.default)(components[p], _templateModeTypes.EMAIL))
              )
            );
          })
        )
      );
    }
  }]);
  return Email;
}(_react.Component);

exports.default = Email;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Tabs/Email/Email.jsx
// module id = 1557
// module chunks = 0